import React from 'react';

interface Props {
  content: string;
}

const UzyToolDefault: React.FC<Props> = ({ content }) => (
  <div className="uzy-tool-card">
    <div className="uzy-tool-card-body">{content}</div>
  </div>
);

export default UzyToolDefault;
